import React, { useRef, useState, useCallback } from "react";

// One carousel slide: image + optional caption.
//
// The caption is anchored to the corner of the *rendered image*, not the fixed
// slide box. The image is shown contained and centered, so a wide image
// (e.g. 16:6) leaves empty bands above/below it and a tall one leaves bands on
// the sides. A box-anchored caption (right:24 / bottom:20) would float in
// those bands, off the image. We compute the letterbox/pillarbox padding from
// the image's natural aspect vs the box and inset the caption by it.
//
// The Style/Legenda styled-components are passed in so each carousel keeps its
// own (they are defined per-slider).
export default function CarouselSlideContent({
  Style,
  Legenda,
  image,
  idTrim,
  bindProps,
  onClick,
}) {
  const boxRef = useRef(null);
  const imgRef = useRef(null);
  const [pad, setPad] = useState({ x: 0, y: 0 });

  const measure = useCallback(() => {
    const box = boxRef.current;
    const img = imgRef.current;
    if (!box || !img || !img.naturalWidth || !img.naturalHeight) return;
    const boxW = box.clientWidth;
    const boxH = box.clientHeight;
    const imgAspect = img.naturalWidth / img.naturalHeight;
    if (imgAspect > boxW / boxH) {
      // wider than box: full width, bands top/bottom
      setPad({ x: 0, y: Math.max(0, (boxH - boxW / imgAspect) / 2) });
    } else {
      // taller than box: full height, bands left/right
      setPad({ x: Math.max(0, (boxW - boxH * imgAspect) / 2), y: 0 });
    }
  }, []);

  return (
    <Style ref={boxRef} {...bindProps}>
      <img
        ref={imgRef}
        draggable="false"
        src={image.url}
        id={idTrim}
        onLoad={measure}
        onClick={onClick}
      />
      {image.text ? (
        <Legenda style={{ right: 24 + pad.x, bottom: 20 + pad.y }}>
          {image.text}
        </Legenda>
      ) : null}
    </Style>
  );
}
